exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification--block{position:relative}.notification--block .notification--block__inner-container{padding-right:25px}.notification--block .dismiss-btn{cursor:pointer;position:absolute;top:5px;right:12.5px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/AlertMessage/index.scss
// module id = 1007
// module chunks = 0